import type { ReactNode } from "react";

export function SwotDashboardGrid(props: { readonly children?: ReactNode | undefined; readonly labelledBy?: string | undefined }) {
  return <section className="swot-dashboard-grid" aria-labelledby={props.labelledBy}>{props.children}</section>;
}
